// extracted by mini-css-extract-plugin
export default {"wrapper":"TableActions_wrapper__+EIXs","actions":"TableActions_actions__-amUF","token":"TableActions_token__HVMi3"};